export const prerareQueryString = (link?: string) => {
  return link?.split('?')[1] || '';
};
